import { produce } from 'immer';
import { NOTIFICATION_SEND, NOTIFICATION_UPDATE, NOTIFICATION_DISMISS, NOTIFICATIONS_CLEAR } from '../actions/notifications';
const defaultState = {
  notifications: []
};
const notifications = produce((state, action) => {
  switch (action.type) {
    case NOTIFICATIONS_CLEAR:
      state.notifications = [];
      break;
    case NOTIFICATION_DISMISS:
      state.notifications = state.notifications.filter(n => n.id !== action.id);
      break;
    case NOTIFICATION_SEND:
      state.notifications = [...state.notifications, {
        // The caller may name the id when it intends to update this
        // notification later; otherwise one is minted here as before.
        id: action.payload.id ?? crypto.randomUUID(),
        ...action.payload
      }];
      break;
    case NOTIFICATION_UPDATE:
      state.notifications = state.notifications.map(notification => notification.id === action.id ? {
        ...notification,
        ...action.payload
      } : notification);
      break;
  }
}, defaultState);
export default notifications;